import { normalizeTicketType } from "screens/tickets/helpers/mapper";
import { statusMapper } from "screens/tickets/helpers/mapper";
import { formatDate, formatTime } from "services/helpers/formatter";

export default function TicketSection(props) {
  return (
    <div className="cursor-pointer">
      {props.tickets.map((ticket, idx) => {
        const { firstCategory } = normalizeTicketType(ticket.type);
        const { title, fontClass, bgClass } = statusMapper(ticket.status);
        return (
          <div
            className={`border-b py-2.5 px-5 flex justify-between space-x-2 ${
              ticket.id === props.selectedTicketId ? "bg-primary-100" : "bg-white hover:bg-gray-50"
            }`}
            onClick={() => props.onClickTicket(ticket.id, ticket.isReadByUser)}
            aria-hidden
            key={idx}
          >
            <div>
              <div className="text-primary text-xxs">{ticket.id.toUpperCase()}</div>
              <div className="mt-1 mb-2">
                <div className="font-bold text-gray-900">{ticket.title}</div>
                <div className="text-gray-800 text-xs">{firstCategory}</div>
              </div>
              <div className="text-gray-700 text-xs">{`${formatDate(
                ticket.createdAt
              )}, ${formatTime(ticket.createdAt)}`}</div>
            </div>
            <div className="flex flex-col justify-between items-end">
              <div
                className={`py-1 px-3 ${bgClass} ${fontClass} font-bold text-xxs rounded-lg min-w-[65px] text-center`}
              >
                {title}
              </div>
              {/* {!ticket.isReadByUser && (
                <div className="p-1 bg-primary-200 rounded-lg">
                  <div className="py-0.5 px-2 bg-primary text-white text-xxs font-bold rounded-md">
                    Pesan Baru
                  </div>
                </div>
              )} */}
            </div>
          </div>
        );
      })}
    </div>
  );
}
